import SearchIcon from "@mui/icons-material/Search";
import {
	Grid2,
	IconButton,
	InputAdornment,
	Paper,
	TextField,
} from "@mui/material";
import React from "react";
import { ShiftDayNavigatorControl } from "../../../../../controls";
import { AssetsFilter } from "../../../../../controls/asset-filter/AssetFilter";
import { AssetTreePicker } from "../../../../../controls/asset-tree-picker/AssetTreePicker";
import { useMesfRealtime } from "../../../../../hooks/useMesfRealtime";

type Props = {
	withAssetFilter?: "tree" | "selector";
	filterAssets?: "area";
	assetId?: number | null;
	setAssetId?: (assetId: number | null) => void;
	quickFilter: string;
	onQuickFilterChange: (text: string) => void;
};

export const Filters = ({
	withAssetFilter,
	filterAssets,
	assetId,
	setAssetId = () => {},
	quickFilter,
	onQuickFilterChange,
}: Props) => {
	useMesfRealtime({
		onReceiveMessage: (author, message) => {
			if (message.replaceAll("[", "").replaceAll("]", "") == "LB.GetEntries") {
			}
		},
	});

	return (
		<Grid2
			container
			justifyContent="center"
			alignItems="center"
			component={Paper}
			size={{ md: 12 }}
			spacing={1}
			p={1}
		>
			<Grid2 maxWidth={"fit-content"} justifyContent="center">
				<ShiftDayNavigatorControl preventInit withPaper={false} />
			</Grid2>
			{withAssetFilter === "tree" && (
				<Grid2 size={{ md: 4.5, xs: 12 }}>
					<AssetTreePicker
						label="Asset"
						value={assetId || 0}
						onChange={(value) => setAssetId(value ?? null)}
						filterAssets={filterAssets === "area"}
					/>
				</Grid2>
			)}
			{withAssetFilter === "selector" && (
				<Grid2 size={{ md: 4.5, xs: 12 }}>
					<AssetsFilter
						value={assetId ?? null}
						onChange={(newValue) => {
							setAssetId(newValue ?? null);
						}}
						filterAreaAssets={filterAssets === "area"}
						isFilter
					/>
				</Grid2>
			)}
			<Grid2 size={{ xs: 12 }}>
				<TextField
					label="Search"
					value={quickFilter}
					onChange={(
						event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
					) => {
						onQuickFilterChange(event?.target.value);
					}}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<IconButton edge="start" type="submit">
										<SearchIcon />
									</IconButton>
								</InputAdornment>
							),
						} as any,
					}}
				/>
			</Grid2>
		</Grid2>
	);
};
